import React from 'react';
import { Router } from '@reach/router';

import Dashboard from '../../Dashboard';
import Book from '../../Book';
import TokenCheck from './TokenCheck';
import StorySelector from '../../Dashboard/scenes/StorySelector';
import ClassProjectsPage from '../../Dashboard/scenes/class-pojects-page/ClassProjectsPage';
import ClassPublishedBooksPage from '../../Dashboard/scenes/class-published-books-page/ClassPublishedBooksPage';


const AppRouter = () => {
    return (
        <Router>
            <TokenCheck path='/'>
                <Dashboard path='/' default />
                <Book path='/book/:bookId' />
                <StorySelector path='/selectStory'/>
                <ClassProjectsPage path='/classProjects'/>
                <ClassPublishedBooksPage path='/classPublishedBooks'/>
            </TokenCheck>
        </Router>
    )
}

export default AppRouter;